import axios from 'axios'
import dayjs from 'dayjs'
// 引入 vuex 的数据
import store from '@/store'
// 引入 Element UI 中的 Message 提示
import { Message } from 'element-ui'

import router from '@/router'

// create  创建 axios 实例
const request = axios.create({
  timeout: 20000
//   baseURL: 'http://localhost:8086/'
})

function getBaseURL (url) {
  // console.log(url)
  return process.env.VUE_APP_BASE_URL // 使用环境变量
  // return 'http://localhost:40001/' // 调试
  // return 'https://scnuXueliBack.gdou.com/' // 调试
  // return '/api' // 生产
}

// 请求拦截器
// request.interceptors.request.use(function (config) {
//   // 判断 config.url 的前缀，来进行请求 baseURL 的设置
//   config.baseURL = getBaseURL(config.url)

//   // 统一设置 Token 信息
//   const { user } = store.state
//   if (user && user.tokenInfo && user.tokenInfo.tokenValue) {
//     config.headers[user.tokenInfo.tokenName] = user.tokenInfo.tokenValue
//   }
//   return config
// })
// let isTokenInvalid = false
// let lastErrorMessage = ''
// let lastErrorTime = 0
// const errorDisplayInterval = 5000 // 5秒钟间隔
// // 响应拦截器
// request.interceptors.response.use(function (response) {
//   // 状态码 2XX 会执行这里
//   const { code, msg } = response.data
//   // console.log('返回值', response)
//   let errorMessage = ''

//   // 检查 msg 是否包含 "token 无效" 子串
//   if ((msg && (msg.includes('token 无效') || msg.includes('未能读取到有效 token')))) {
//     if (!isTokenInvalid) {
//       isTokenInvalid = true
//       // 处理token失效的情况
//       router.push({ name: 'login' })
//       displayError('登录信息过期，请重新登录')
//     }
//     return Promise.reject(new Error('Token 无效'))
//   }

//   if (code === 400) {
//     errorMessage = '请求参数错误'
//   } else if (code === 401) {
//     // 跳转到登录页面
//     router.push({ name: 'login' })
//   } else if (code === 403) {
//     errorMessage = '没有权限，请联系管理员'
//   } else if (code === 404) {
//     errorMessage = '请求资源不存在'
//   } else if (code === 500) {
//     errorMessage = '服务端错误，请联系管理员'
//   } else {
//     return response
//   }
//   // console.log(errorMessage)
//   displayError(errorMessage)
//   return Promise.reject(new Error(errorMessage))
// }, function (error) {
//   // console.dir(error)
//   if (error.response) {
//     // 请求发送成功，响应接收完毕，但状态码为失败的情况
//     // 1.判断失败的状态码（主要处理 401 的情况）
//     const { status } = error.response
//     let errorMessage = ''
//     if (status === 400) {
//       errorMessage = '请求参数错误'
//     } else if (status === 401) {
//       // errorMessage = 'Token 无效'
//       router.push({ name: 'login' })
//       displayError('登录信息过期，请重新登录')
//     } else if (status === 403) {
//       errorMessage = '没有权限，请联系管理员'
//     } else if (status === 404) {
//       errorMessage = '请求资源不存在'
//     } else if (status === 500) {
//       errorMessage = '服务端错误，请联系管理员'
//     }
//     // console.log(errorMessage)
//     displayError(errorMessage)
//   } else if (error.request) {
//     // 请求发送成功，但是未收到响应
//     displayError('请求超时，请重试')
//   } else {
//     // 意料之外的错误
//     if (error.message === 'Network Error') {
//       displayError('网络错误，请检查你的网络连接')
//     } else {
//       displayError(error.message)
//     }
//   }
//   // 利用下面的打印语句能看到具体的错误信息
//   // console.dir(error)
//   // return Promise.reject(error)
//   return Promise.resolve()
// })

// function displayError (message) {
//   const currentTime = Date.now()
//   if (message !== lastErrorMessage || (currentTime - lastErrorTime) > errorDisplayInterval) {
//     lastErrorMessage = message
//     lastErrorTime = currentTime
//     Message.error(message)
//   }
// }
// 请求拦截器
request.interceptors.request.use(function (config) {
  // 判断 config.url 的前缀，来进行请求 baseURL 的设置
  config.baseURL = getBaseURL(config.url)

  // 统一设置 Token 信息
  const { user } = store.state
  if (user && user.tokenInfo && user.tokenInfo.tokenValue) {
    config.headers[user.tokenInfo.tokenName] = user.tokenInfo.tokenValue
  }
  return config
})
let isTokenInvalid = false
let lastErrorMessage = ''
let lastErrorTime = 0
const errorDisplayInterval = 5000 // 5秒钟间隔
// 响应拦截器
request.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.config.handleErrorLocally) {
    // 将错误直接返回，让调用处处理
    return Promise.reject(error)
  }

  // 全局错误处理
  if (error.response) {
    const { status, data } = error.response
    let errorMessage = data.message || '发生未知错误'

    switch (status) {
      case 400: errorMessage = '请求参数错误，请检查是否漏填或漏选信息'; break
      case 401:
        if (!isTokenInvalid) {
          isTokenInvalid = true
          router.push({ name: 'login' })
        }
        errorMessage = '登录信息过期，请重新登录'
        break
      case 403: errorMessage = '没有权限，请联系管理员'; break
      case 404: errorMessage = '请求资源不存在'; break
      case 500: errorMessage = '服务端错误，请联系管理员'; break
      default: break
    }

    displayError(errorMessage)
    return Promise.reject(new Error(errorMessage))
  } else {
    // 网络或其他类型的错误
    displayError('网络错误，请检查你的网络连接')
    return Promise.reject(error)
  }
})

function displayError (message) {
  const currentTime = Date.now()
  if (message !== lastErrorMessage || (currentTime - lastErrorTime) > errorDisplayInterval) {
    lastErrorMessage = message
    lastErrorTime = currentTime
    Message.error(message)
  }
}
export default request

export const formatExport = async (url, { params, data, filename, method }) => {
  const res = await request.request(url, {
    method: method || 'post',
    data,
    params,
    responseType: 'blob'
  })
  if (res) {
    const url = window.URL.createObjectURL(res)
    const a = document.createElement('a')
    a.href = url
    a.download = (filename || '导出文件') + dayjs().format('YYYY-MM-DD HH:mm:ss') + '.xlsx'
    a.click()
    window.URL.revokeObjectURL(url)
  }
}
